import { Box, Typography } from "@bca/ui-library";

import MobileCard from "./MobileCard";
import DetailedCard from "./DetailedCard";

const ClaimsBottomSection = () => {
  return (
    <Box
      as="section"
      width="100%"
      height="fit-content"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
    >
      <Box
        as="ol"
        hidden
        display={["flex", "none"]}
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        p={0}
      >
        <MobileCard
          icon="flag"
          link={`${process.env.VIRTUAL_DOMAIN}help/missing-items`}
          headline="Missing items"
          description="Report missing items"
          ariaLabel="Missing items"
          analytics={{
            eventName: "click",
            eventCategory: "card",
            eventLabel: "report-missing-items",
            eventAction: "start",
            eventSection: "secondary-information",
          }}
        />
        <MobileCard
          icon="file-invoice"
          link={`${process.env.VIRTUAL_DOMAIN}help/customer-claims/`}
          headline="Claims"
          description="Submit a claim for a purchase"
          ariaLabel="Claims"
          analytics={{
            eventName: "click",
            eventCategory: "card",
            eventLabel: "make-a-claim",
            eventAction: "start",
            eventSection: "secondary-information",
          }}
        />
      </Box>
      <Box
        hidden
        as="ol"
        display={["none", "flex"]}
        width="100%"
        p={0}
        justifyContent="space-between"
      >
        <DetailedCard
          icon="flag"
          link={`${process.env.VIRTUAL_DOMAIN}help/missing-items`}
          headline="Missing items"
          label="Report a Missing Item"
          ariaLabel="Missing items"
          analytics={{
            eventName: "click",
            eventCategory: "card",
            eventLabel: "report-missing-items",
            eventAction: "start",
            eventSection: "secondary-information",
          }}
        >
          <Typography
            variant="h6"
            htmlTag="p"
            color="#374d62"
            fontWeight="light"
            mt={4}
            mb="auto"
          >
            Please check the vehicle including the boot in case the missing
            items have been left there. If the missing items are not in the
            vehicle please use this form.
          </Typography>
        </DetailedCard>
        <DetailedCard
          icon="file-invoice"
          link={`${process.env.VIRTUAL_DOMAIN}help/customer-claims/`}
          headline="Claims"
          label="Make a Claim"
          ariaLabel="Claims"
          analytics={{
            eventName: "click",
            eventCategory: "card",
            eventLabel: "make-a-claim",
            eventAction: "start",
            eventSection: "secondary-information",
          }}
        >
          <Typography
            variant="h6"
            htmlTag="p"
            color="#374d62"
            fontWeight="light"
            mt={4}
            mb="auto"
          >
            If you think there is something on the <strong>grading</strong> or{" "}
            <strong>assured report</strong> of your purchased vehicle has been
            misreported, you might be eligible to make a claim.
          </Typography>
        </DetailedCard>
      </Box>
    </Box>
  );
};

export default ClaimsBottomSection;
